export const isValueSet = <T>(value?: T | null): value is T =>
    value !== null && value !== undefined;

export const isNotEmpty = <T extends string | Array<unknown>>(value?: T | null): value is T =>
    isValueSet<T>(value) && value.length > 0;

export const isEmpty = <T extends string | Array<unknown>>(value: T): value is T =>
    value?.length === 0;

export const optionalValue = <T>(value?: T | null): T | null => {
    if (Array.isArray(value) || typeof value === 'string') {
        return isNotEmpty(value) ? value : null;
    }

    return isValueSet<T>(value) ? value : null;
};
